import { L } from '@lib';
import { RequestPriority } from '@models';
import { Tag, Typography } from 'antd';
import { BLUE, DANGER } from '../Theme/palette';
import React from 'react';

const { Text } = Typography;

interface IProps {
  priority: string;
}

export const RequestPriorityTag: React.FC<IProps> = ({ priority }) => {
  return (
    <>
      {priority === RequestPriority.High && (
        <Tag color={DANGER.soft} style={{ border: `1px solid ${DANGER.tag}` }}>
          <Text style={{ color: DANGER.tag }}>{L('High')}</Text>
        </Tag>
      )}
      {priority === RequestPriority.Medium && (
        <Tag color={BLUE.soft} style={{ border: `1px solid ${BLUE.badge}` }}>
          <Text style={{ color: BLUE.badge }}>{L('Medium')}</Text>
        </Tag>
      )}
      {priority === RequestPriority.Low && (
        <Tag color="#F2F6CE" style={{ border: '1px solid #638A00' }}>
          <Text style={{ color: '#638A00' }}>{L('Low')}</Text>
        </Tag>
      )}
    </>
  );
};
